<template>
    <el-dialog :visible.sync="show" width="500px">
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="70px" style="height: 50vh; overflow-y: auto">
                    <div style="display: flex; align-items: center; flex-direction: column">
                        <h1 style="font-size: 30px; color: #00b38a">微信扫一扫支付</h1>
                        <el-image :src="wxpayUrl">
                            <div slot="error" class="image-slot">加载中<span class="dot">...</span></div>
                        </el-image>
                        <div>注：若二维码过期失效，请关闭页面后重新进入该页面进行支付！</div>
                    </div>
                </el-form>
                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center">
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-dialog>
</template>
<script>
var _this;
let myTimer;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;
            console.log(111);
            _this.submit_data.amount = _this.data;
            console.log(_this.submit_data.amount, '_this.submit_data.amount');
            _this.handlePayWxQRcode();
        }
    },
    data() {
        return {
            show: false,
            wxpayUrl: '',
            submit_url: '',
            // 表单数据
            submit_data: {
                amount: ''
            },
            submit_rules: {
                amount: {
                    placeholder: '充值金额',
                    rules: {
                        required: true,
                        message: '充值金额',
                        regulation: 'egt',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        //获取充值二维码
        handlePayWxQRcode() {
            _this.$post('/service_fee/rechargeServiceFee', this.submit_data).then((res) => {
                _this.wxpayUrl = res.data.parameter.code_url_base64;

              
                    _this.payStatus(res.data.parameter.trade_no);
               

                
            });
        },
        // 轮询,如果状态不是完成，每3秒查询一下状态，如果状态为完成，则关闭充值二维码页面
        payStatus(val) {
            axios.defaults.baseURL = config.axios_normalURL;

            _this.$post('/wechat/payStatus', { trade_no: val }).then((res) => {
                axios.defaults.baseURL = config.axios_baseURL; //请求base url
             

                if (res.data.status != '1') {
                    myTimer = setTimeout(() => {
                        _this.payStatus(val);
                    }, 3000);
                   
                }else{
                    _this.$emit('onSubmit');
               
                    _this.closeDialog();

                }

            });
        },

        // 关闭方法
        closeDialog() {
            clearTimeout(myTimer);
            _this.show = false;
            

            _this.wxpayUrl = '';

            for (const key in _this.submit_data) {
                _this.submit_data[key] = '';
            }
        }
    }
};
</script>
<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
